import { render, staticRenderFns } from "./cardIndicator.vue?vue&type=template&id=33a2fcfe&scoped=true"
import script from "./cardIndicator.vue?vue&type=script&lang=js"
export * from "./cardIndicator.vue?vue&type=script&lang=js"
import style0 from "./cardIndicator.vue?vue&type=style&index=0&id=33a2fcfe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2fcfe",
  null
  
)

export default component.exports